import { SearchBarType } from "@/components/dynamic-form/constants";
import {
  IDataPickerSearchConfig,
  SearchConfig,
} from "@/components/dynamic-form";

/**
 * 别用这里的函数
 */

export function getSingleConfig(
  searchConfig: SearchConfig[],
  field: string,
  type: SearchBarType.DatePicker
): IDataPickerSearchConfig;
export function getSingleConfig(
  searchConfig: SearchConfig[],
  field: string,
  type: SearchBarType
) {
  return searchConfig.find((c) => c.field === field && c.type === type);
}

export const getDataPickerSearchConfig = (
  searchConfig: SearchConfig[],
  field: string
) => getSingleConfig(searchConfig, field, SearchBarType.DatePicker);

/**
 * 别用这里的函数
 */
